import React, { useId } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import type { Placement } from "react-bootstrap/esm/types";
import styles from "./CygnusTooltip.module.css";

const tooltipContainer = typeof window !== "undefined" ? document.body : undefined;

interface CygnusTooltipProps {
  text: React.ReactNode;
  children: React.ReactElement;
  placement?: Placement;
  disabled?: boolean;
}

export const CygnusTooltip: React.FC<CygnusTooltipProps> = ({
  text,
  children,
  placement = "top",
  disabled = false,
}) => {
  const id = useId();

  if (disabled || !text) return children;

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 150, hide: 80 }}
      trigger={["hover", "focus"]}
      container={tooltipContainer}
      overlay={<Tooltip id={id} className={styles.tooltip}>{text}</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  );
};
